import React, { FC, HTMLAttributes } from 'react';
import cn from 'classnames';
import style from './style.module.scss';

type TProps = {
  name: string;
} & HTMLAttributes<HTMLElement>;

const Icon: FC<TProps> = ({ name, className, ...restProps }) => {
  return (
    <i
      className={cn(style.icon, style[name], className)}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...restProps}
    />
  );
};

export default Icon;
